import defaultStyles from './default';
import navStyles from './nav';
import colorStyles from './color';

const styles = Object.assign({}, defaultStyles, navStyles, colorStyles);

export default styles;
